import styled from 'styled-components';
import { ButtonLink, Icon, TextBlock } from 'bench-internal-theme';
import { colors } from 'bench-style-constants';

export const LedgerAccountHeaderLayout = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  grid-column-gap: 12px;
  grid-template-columns: auto max-content;
  padding: 16px 0 16px;
  width: 100%;
  align-items: flex-end;
  background-color: ${colors.white};
  min-height: 100px;
`;

export const LedgerDescriptionLayout = styled.div`
  display: grid;
`;

export const LedgerNameLayout = styled.div`
  align-items: flex-start;
  display: grid;
  grid-template-columns: max-content max-content;
  grid-column-gap: 8px;
`;

export const LedgerNameButton = styled(ButtonLink)`
  color: ${colors.charcoal};
  font-weight: bold;
`;

export const DownloadIcon = styled(Icon)`
  display: block;
`;

export const BalancesLayout = styled.div`
  display: grid;
  grid-column-gap: 8px;
  grid-row-gap: 12px;
  grid-template-columns: max-content max-content max-content;
  grid-template-rows: 16px;
  float: right;
`;

export const NoteText = styled(TextBlock).attrs(() => ({
  color: colors.smoke,
  styleType: 'small',
}))`
  width: calc(100% - 200px);
  max-width: 700px;
`;
